import emailjs from '@emailjs/browser';

// Load environment variables 
const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

// Send Email Function
export const sendTransactionEmail = async (userEmail, accountNumber, userName, transactionData) => {
  try {
    const response = await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      {
        user_name: userName,
        account_number: accountNumber,
        user_email: userEmail, 
        amount: transactionData.amount,
        bank_name: transactionData.bankName || "John Doe",
        beneficiary: transactionData.beneficiary,
        type: transactionData.type,
        beneficiary_account: transactionData.beneficiaryAccount
      },
      PUBLIC_KEY
    );

    console.log('✅ Email sent successfully:', response);
    return true;
  } catch (error) {
    console.error('❌ Error sending email:', error);
    return false;
  }
};
